import React from 'react';
import { BarChart } from '@mui/x-charts';
import { Box, Typography, Tab } from "@mui/material";

const StackedBarChartForteamReview = ({ data, height = 243, title, yAxisLabel, xAxisDataKey, valueFormatterReq,xAxisLabel }) => {

    const stackKeys = Object.keys(data[0] || {}).filter(key => ['auto_rejections', 'manual_rejections'].includes(key));

    const dataKeys = data?.length ? stackKeys.filter(key => key in data[0]) : [];

    // color palette
    const palette = [
        '#3A238C',
        '#543EA3',
        '#6754AD',
        '#7B6AB8',
        '#9384C7',
        '#A296CC',
        '#B9AFDB',
        '#D1CAEB',
        '#E2DCF2',
        '#F0EDFA'
    ];

    //Map datakeys to colors
    const buColors = {};
        dataKeys.forEach((legendKey, idx) => {
            buColors[legendKey] = palette[idx % palette.length];
    });

    //Prepare series and data
    const series = dataKeys.map((legendKey, idx) => ({
        dataKey: legendKey,
        label: legendKey.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
        stack: 'total',
        color: buColors[legendKey],
    }));

    return (
        <Box sx={{width: "100%", boxSizing: "border-box", padding: "24px", border: '1px solid #E5E5E5', borderRadius: '8px', background: '#fff'}}>
        <Typography variant="h6" component="h4" sx={{fontSize: '20px', fontWeight: 700, color: '#111', mb: 4}}>
            {title}
        </Typography>
        <BarChart
            series={series}
            xAxis={[
                {
                    scaleType: "band",
                    dataKey: xAxisDataKey,
                    label:xAxisLabel,
                    valueFormatter: (value, context) => {
                        if (context.location === "tick") {
                            return ""
                        }
                        return value.charAt(0).toUpperCase() + value.slice(1)
                    }
                },
            ]}
            yAxis={[
            {
                label: yAxisLabel,
            },
            ]}
            dataset={data}
            height={height}
            sx={{
                '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
                '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
                '& .MuiChartsAxis-root .MuiChartsAxis-tick': {stroke: 'var(--grey-CCC)' }
            }}
            slotProps={{
            legend: {
                sx: {
                    width: '100%',
                    marginLeft: "30px",
                    height: "40px",
                    marginBottom: '20px',
                    flexDirection: 'column',
                    overflowX: 'auto'
                },
            },
        }}

        />
        </Box>
    );
};

export default StackedBarChartForteamReview;